// extracted by mini-css-extract-plugin
module.exports = {"location":"Location-hashed__location__3uBmt","location__icon":"Location-hashed__location__icon__2NqMh","location__address":"Location-hashed__location__address__2xaqO"};